export default {
  LOGIN: `Login`,
  SUBMIT: `Submit`,
  COMPANY: {
    LABEL: `Company`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Enter the beginning of your company URL`
  },
  USERNAME: {
    LABEL: `Identification`,
    PLACEHOLDER: `Username, email or employee number`,
    DESCRIPTION: ``
  },
  EMAIL: {
    LABEL: `Email`,
    PLACEHOLDER: `Please enter your email`,
    DESCRIPTION: `You must use the email linked to your account`
  },
  USERNAMEOREMAIL: {
    LABEL: `Username or email`,
    PLACEHOLDER: `Please enter either your username or your email`,
    DESCRIPTION: `You must use the email linked to your account`
  },
  PASSWORD: {
    LABEL: `Password`,
    PLACEHOLDER: `Please enter your password`,
    DESCRIPTION: ``
  },
  REQUIRED: `This field is required.`,
  USERNAME_CANT_BE_COMPANY: `You have entered the company name instead of your username.`,
  TOO_SHORT: `Content too short`,
  TOO_LONG: `Content too long`,
  FORGOT_PASSWORD: `Forgot password`,
  FORGOT_PASSWORD_CARD: {
    TITLE: `Forgot password`,
    SUMMARY: `To reset your password, please enter your username or email below.`
  },
  FORGOT_USERNAME: `Forgot username`,
  FORGOT_USERNAME_CARD: {
    TITLE: `Forgot username`,
    SUMMARY: `To recover your username, please enter your email below.`
  },
  FORGOT_COMPANY: {
    TITLE: `Forgot company`,
    SUMMARY: `Request the your company url by email.`
  },
  forgotCompany: {
    EMAIL_SENT_TO_THIS_EMAIL: `An email has been sent to your email address with the URL of the company.`,
    NO_COMPANY_FOUND_FOR_THIS_EMAIL: `No company found associated with this email address`
  },
  USERNAME_PASSWORD_INVALID: `Username or password invalid`,
  USERNAME_EMAIL_NOT_FOUND: `Email or username not found, please contact your manager.`,
  NO_USERNAME_EMAIL_ASSOCIATED: `No account is associated with this email and username, please contact your manager.`,
  EMAIL_NOT_FOUND: `Email not found, please contact your manager.`,
  NEED_USERNAME: 'Multiple users have this email, please enter your username.',
  SAME_EMAIL_CONTACT_MANAGER: 'Multiple users have this email, please contact your manager.',
  MUST_BE_A_VALID_EMAIL: `The email address must be valid.`,
  RETURN: `Return to the login page`,
  LOGIN_ERROR: `Login Error`,
  INVALID_COMPANY: `The company url ({{ co }}) you have entered is invalid.`,
  NO_COMPANY_EXISTS_ON_URL: `There is no company associated with {{ co }}.merinio.com.`,
  FIND_MY_COMPANY: `Find my company`,
  RETURN_COMPANY: `Return`,
  EMAIL_PASSWORD_CONFIRMATION: `Your password reset link was sent by email!`,
  EMAIL_USERNAME_CONFIRMATION: `Your username recovery link was sent by email!`,
  EMAIL_COMPANY_CONFIRMATION: `Your company url was sent by email!`,
  NO_INTERNET: `It looks like you are not connected to the internet.`
}
